<mat-card class="chart-card">
  <mat-card-header>
    <mat-card-title>{{ 'analytics.applicationsDashboard' | transloco }}</mat-card-title>
    <mat-card-subtitle>{{ 'analytics.applicationMetrics' | transloco }}</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <!-- SSR placeholder -->
    <div *ngIf="!isBrowser" class="ssr-placeholder">
      <p>{{ 'analytics.loadingDashboard' | transloco }}</p>
    </div>

    <!-- Render dashboard only in browser -->
    <ng-container *ngIf="isBrowser">
      <!-- Loading state -->
      <div *ngIf="loading" class="loading-overlay">
        <mat-spinner diameter="50"></mat-spinner>
        <p>{{ 'analytics.loadingAnalytics' | transloco }}</p>
      </div>

      <!-- Error state -->
      <div *ngIf="error && !loading" class="error-message">
        <p>{{ error }}</p>
      </div>

      <!-- Dashboard Content -->
      <div *ngIf="!loading && !error" class="dashboard-content">
        <!-- Summary Statistics Cards -->
        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-label">{{ 'analytics.totalApplications' | transloco }}</div>
            <div class="stat-value">{{ totalApplications | number }}</div>
          </div>

          <div class="stat-card">
            <div class="stat-label">{{ 'analytics.totalUniqueJobs' | transloco }}</div>
            <div class="stat-value">{{ totalUniqueJobs | number }}</div>
          </div>

          <div class="stat-card">
            <div class="stat-label">{{ 'analytics.avgApplicationsPerJob' | transloco }}</div>
            <div class="stat-value">{{ avgPerJob | number : '1.1-1' }}</div>
          </div>
        </div>

        <!-- Time Series Chart -->
        <div class="breakdown-section time-series-section">
          <div class="chart-header">
            <h3>{{ 'analytics.timeSeries' | transloco }}</h3>
            <p class="chart-subtitle">{{ 'analytics.applicationsOverTime' | transloco }}</p>
          </div>
          <div class="chart-container">
            <ngx-charts-line-chart
              *ngIf="timeSeriesData.length > 0"
              [scheme]="timeSeriesColorScheme"
              [results]="timeSeriesData"
              [gradient]="gradient"
              [xAxis]="showXAxis"
              [yAxis]="showYAxis"
              [legend]="showLegend"
              [legendPosition]="legendPosition"
              [showXAxisLabel]="showXAxisLabel"
              [showYAxisLabel]="showYAxisLabel"
              [xAxisLabel]="'analytics.xAxisDate' | transloco"
              [yAxisLabel]="'analytics.yAxisCount' | transloco"
              [animations]="animations"
              [yAxisTickFormatting]="yAxisTickFormatting"
              (select)="onSelect($event)"></ngx-charts-line-chart>

            <div *ngIf="timeSeriesData.length === 0" class="no-data">
              <p>{{ 'analytics.noTimeSeriesData' | transloco }}</p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </mat-card-content>
</mat-card>
